import * as React from 'react';

const initScrollHandler = (_event: number) => {
    return;
};

export const ScrollPositionContext = React.createContext<{
    scroll: number;
    updateScrollPosition: (scrollVal: number) => void;
}>({ scroll: 0, updateScrollPosition: initScrollHandler });

export const ScrollPositionContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [scroll, setScroll] = React.useState(0);

    const updateScrollPosition = (scrollVal: number) => {
        setScroll(scrollVal);
    };

    return (
        <ScrollPositionContext.Provider value={{ scroll, updateScrollPosition }}>
            {children}
        </ScrollPositionContext.Provider>
    );
};
